import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CustomPipesModule } from '../custom-pipes.module';
import { HeaderComponent } from './header.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CogButtonComponent } from './cog-button/cog-button.component';
import { FeedbackModalComponent } from './-components-/feedback-modal/feedback-modal.component';
import { ContactFormComponent } from './-components-/contact-form/contact-form.component';
import { ProfileButtonContainerComponent } from './profile-buttons/profile-button-container.component';
import { ProfileButtonLoggedinComponent } from './profile-buttons/profile-button-loggedin/profile-button-loggedin.component';
import { ProfileButtonLoggedoutComponent } from './profile-buttons/profile-button-loggedout/profile-button-loggedout.component';
import { NotificationListComponent } from './notification-list/notification-list.component';
import { MaintenanceLogoutDialogComponent } from './maintenance-logout-dialog.component';
import { ConnectionStatusComponent } from './connection-status.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgLetModule } from 'ng-let';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenubarModule } from 'primeng/menubar';
import { SidebarModule } from 'primeng/sidebar';
import { DataViewModule } from 'primeng/dataview';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CustomCommonModule } from '../custom-common.module';
import { SystemAnnouncementService } from 'src/app/system-announcements/system-announcements.service';
import { HeaderService } from './header.service';
import { HeaderAnnouncementService } from './header-announcement.service';
import { HeaderAuthService } from './header-auth.service';
import { HeaderLogoService } from './header-logo.service';
import { HeaderNotificationService } from './header-notification.service';

@NgModule({
  declarations: [
    HeaderComponent,
    BreadcrumbComponent,
    CogButtonComponent,
    FeedbackModalComponent,
    ContactFormComponent,
    ProfileButtonContainerComponent,
    ProfileButtonLoggedinComponent,
    ProfileButtonLoggedoutComponent,
    NotificationListComponent,
    MaintenanceLogoutDialogComponent,
    ConnectionStatusComponent
  ],
  exports: [HeaderComponent],
  imports: [
    CommonModule,
    NgLetModule,
    FormsModule,
    BreadcrumbModule,
    DialogModule,
    ReactiveFormsModule,
    MenubarModule,
    MenuModule,
    MessageModule,
    SidebarModule,
    DataViewModule,
    ButtonModule,
    CustomPipesModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    ToastModule,
    CustomCommonModule
  ],
  providers: [
    HeaderAuthService,
    HeaderLogoService,
    HeaderAnnouncementService,
    HeaderNotificationService,
    HeaderService,
    SystemAnnouncementService,
    MessageService
  ]
})
export class HeaderModule {}
